// European number notation (FT-4743): thousand separator ".", decimal separator ","
// e.g. 1000 -> "1.000,00". Presentation-only — never feed formatted strings back into
// state or API payloads (backends expect dot-decimal machine format).
export const THOUSAND_SEPARATOR = ".";
export const DECIMAL_SEPARATOR = ",";

export type NumberKind = "currency" | "feePerMwh" | "power" | "energy" | "percent" | "profitShare" | "count";

// [minimumFractionDigits, maximumFractionDigits]
const NUMBER_KIND_DIGITS: Record<NumberKind, [number, number]> = {
  currency: [2, 2],
  feePerMwh: [2, 2],
  power: [2, 2],
  energy: [2, 2],
  percent: [0, 0], // whole-number percentages (SoC, DoD, RTE)
  profitShare: [0, 2], // can be fractional; trailing zeros trimmed (12.5 -> "12,5", 20 -> "20")
  count: [0, 0],
};

const formatters = new Map<string, Intl.NumberFormat>();

function getFormatter(min: number, max: number): Intl.NumberFormat {
  const key = `${min}:${max}`;
  let formatter = formatters.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat("nl-BE", {
      minimumFractionDigits: min,
      maximumFractionDigits: max,
    });
    formatters.set(key, formatter);
  }
  return formatter;
}

export function formatNumber(value: number, kind: NumberKind): string {
  const [min, max] = NUMBER_KIND_DIGITS[kind];
  return getFormatter(min, max).format(value);
}
